import React, { ReactElement } from 'react';
import { ButtonBase, ButtonBaseProps } from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import classNames from 'classnames';
import { PRIMARY_BLUE } from '../../Constants/Colors.constants';

interface RectangularButtonProps extends ButtonBaseProps {
  icon?: ReactElement;
}

const useStyles = makeStyles((theme) => ({
  container: {
    fontFamily: 'fitogram, sans-serif',
    fontSize: 12,
    color: PRIMARY_BLUE,
    border: `1px solid ${PRIMARY_BLUE}`,
    letterSpacing: 0.5,
    height: 28,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `0px ${theme.spacing()}`,
    fontWeight: 'bold',
  },
}));

const RectangularButton = ({ children, icon, className, ...props }: RectangularButtonProps) => {
  const { classes } = useStyles();
  return (
    <ButtonBase
      {...props}
      className={classNames({
        [className as string]: !!className,
        [classes.container]: true,
      })}
    >
      {icon}
      {children}
    </ButtonBase>
  );
};

export default RectangularButton;
